import { render, staticRenderFns } from "./DashAutomations.vue?vue&type=template&id=3754ee40&scoped=true&"
import script from "./DashAutomations.vue?vue&type=script&lang=js&"
export * from "./DashAutomations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3754ee40",
  null
  
)

export default component.exports